// Libraries
import { useSnackbar } from "notistack";
import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

// Core
import { ResourceTextApplication } from "../../core/resources";

// Feature
import { ADialog, ADialogActions, ADialogButtonsProp, ADialogContent, ADialogTitle } from "../../common/dialog";

export interface ProducerReturnPdfDialogProps {
    pdfUrl: string;
    onClose: () => void;
}

export default function ProducerReturnPdfDialog(props: ProducerReturnPdfDialogProps) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaProducerReturn', 'AnelmaGeneral']);

    const footerButtons: ADialogButtonsProp = {
        left: [
            {
                onClick: () => props.onClose(),
                type: 'cancel',
                label: t('AnelmaGeneral:1067')
            },
        ],
        right: []
    };

    return (
        <ADialog open onClose={() => props.onClose()}>
            <ADialogTitle>{t('AnelmaProducerReturn:1000')}</ADialogTitle>

            <ADialogContent size='lg'>
                <div>
                    <iframe
                        id={'pdf-iframe'}
                        src={props.pdfUrl}
                        width="100%"
                        height="600px"
                        style={{ border: 'none' }}
                    ></iframe>
                </div>
            </ADialogContent>

            <ADialogActions buttons={footerButtons} />
        </ADialog>
    );
}